module.exports = __webpack_public_path__ + "static/media/3dclustering.15f8f42f.svg";